import { render } from "./AppRadio.vue?vue&type=template&id=6bd2d673&scoped=true&ts=true"
import script from "./AppRadio.vue?vue&type=script&lang=ts"
export * from "./AppRadio.vue?vue&type=script&lang=ts"

import "./AppRadio.vue?vue&type=style&index=0&id=6bd2d673&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd2d673"]])

export default __exports__